import { render, staticRenderFns } from "./officialList.vue?vue&type=template&id=93003af8&scoped=true&"
import script from "./officialList.vue?vue&type=script&lang=js&"
export * from "./officialList.vue?vue&type=script&lang=js&"
import style0 from "./officialList.vue?vue&type=style&index=0&id=93003af8&scoped=true&lang=css&"
import style1 from "./officialList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93003af8",
  null
  
)

export default component.exports